/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Forward_One_SecondInputs */

const en_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go forward one second in the video`)
};

const fr_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancer d'une seconde dans la video`)
};

const de_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spulen Sie im Video eine Sekunde vor.`)
};

const it_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai avanti di un secondo nel video`)
};

const ru_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотайте видео на одну секунду вперед.`)
};

const es_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar un segundo en el vídeo`)
};

const zh_cn2_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频快进一秒。`)
};

const ja_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画を1秒進めます`)
};

const hi_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में एक सेकंड आगे बढ़ें`)
};

const pt_pt2_shortcut_keys_desc_forward_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance um segundo no vídeo.`)
};

/**
* | output |
* | --- |
* | "Go forward one second in the video" |
*
* @param {Shortcut_Keys_Desc_Forward_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_forward_one_second = /** @type {((inputs?: Shortcut_Keys_Desc_Forward_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Forward_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "de") return de_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "it") return it_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "es") return es_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_forward_one_second(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_forward_one_second(inputs)
	return en_shortcut_keys_desc_forward_one_second(inputs)
});